import { CreditCard, Wallet } from 'lucide-react';
import { formatDateTime } from 'utils/dateFormatter';
import { getVerificationStatus } from '../utils';

const FinancialTab = ({ seller, onOpenBankModal }) => {
  const diagnostics = seller?.razorpayDiagnostics;
  const requirements = Array.isArray(diagnostics?.requirements) ? diagnostics.requirements : [];

  

  const prettifyStatus = (value) => {
    if (!value) return 'N/A';
    return String(value).replace(/_/g, ' ');
  };

  return (
    <>
      {/* Bank Details */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <div className='flex items-center justify-between mb-4'>
          <h2 className='text-lg font-semibold flex items-center'>
            <CreditCard className='mr-2' size={20} />
            Bank Details
          </h2>
          {getVerificationStatus(seller?.bankDetails?.isVerified)}
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
          <div>
            <label className='text-xs text-muted-foreground'>Account Holder Name</label>
            <p className='text-sm font-medium mt-1'>{seller?.bankDetails?.accountHolderName || 'N/A'}</p>
          </div>
          <div>
            <label className='text-xs text-muted-foreground'>Account Number</label>
            <p className='text-sm font-medium mt-1'>{seller?.bankDetails?.accountNumber || 'N/A'}</p>
          </div>
          <div>
            <label className='text-xs text-muted-foreground'>IFSC Code</label>
            <p className='text-sm font-medium mt-1'>{seller?.bankDetails?.ifscCode || 'N/A'}</p>
          </div>
          <div>
            <label className='text-xs text-muted-foreground'>Bank Name</label>
            <p className='text-sm font-medium mt-1'>{seller?.bankDetails?.bankName || 'N/A'}</p>
          </div>
          {/* <div>
            <label className='text-xs text-muted-foreground'>Branch Name</label>
            <p className='text-sm font-medium mt-1'>{seller?.bankDetails?.branchName || 'N/A'}</p>
          </div> */}
          <div>
            <label className='text-xs text-muted-foreground'>UPI ID</label>
            <p className='text-sm font-medium mt-1'>{seller?.bankDetails?.upiId || 'N/A'}</p>
          </div>
          {seller?.bankDetails?.verifiedAt && (
            <div>
              <label className='text-xs text-muted-foreground'>Verified At</label>
              <p className='text-sm font-medium mt-1'>{formatDateTime(seller.bankDetails.verifiedAt)}</p>
            </div>
          )}
        </div>
        {!seller?.bankDetails?.isVerified && (
          <div className='mt-4'>
            <button
              onClick={onOpenBankModal}
              className='px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
            >
              Verify Bank Details
            </button>
          </div>
        )}

        {diagnostics && (
          <div className='mt-6 border-t border-border pt-4'>
            <h3 className='text-sm font-semibold text-foreground mb-3'>Razorpay Diagnostics</h3>

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-4'>
              <div className='rounded-md border border-border bg-muted/30 p-3'>
                <p className='text-[11px] text-muted-foreground uppercase tracking-wide'>Activation Status</p>
                <p className='text-sm font-medium mt-1 capitalize'>{prettifyStatus(diagnostics?.activation_status)}</p>
              </div>
              <div className='rounded-md border border-border bg-muted/30 p-3'>
                <p className='text-[11px] text-muted-foreground uppercase tracking-wide'>Account Status</p>
                <p className='text-sm font-medium mt-1 capitalize'>{prettifyStatus(diagnostics?.account_status)}</p>
              </div>
              <div className='rounded-md border border-border bg-muted/30 p-3'>
                <p className='text-[11px] text-muted-foreground uppercase tracking-wide'>Account ID</p>
                <p className='text-sm font-medium mt-1 break-all'>{diagnostics?.accountId || 'N/A'}</p>
              </div>
              <div className='rounded-md border border-border bg-muted/30 p-3'>
                <p className='text-[11px] text-muted-foreground uppercase tracking-wide'>Product ID</p>
                <p className='text-sm font-medium mt-1 break-all'>{diagnostics?.productId || 'N/A'}</p>
              </div>
            </div>

            <div>
  <p className='text-xs text-muted-foreground mb-2'>
    Errors From Razor Pay Verification
  </p>

  {[
    {
      label: 'Step 1 Error',
      value: diagnostics?.step1Error,
    },
    {
      label: 'PAN Verification Error',
      value: diagnostics?.step2Error,
    },
    {
      label: 'PAN Update Error',
      value: diagnostics?.step2UpdateError,
    },
    {
      label: 'Account Activation Error',
      value: diagnostics?.step3Error,
    },
    {
      label: 'Bank Verification Error',
      value: diagnostics?.step4Error,
    },
    {
      label: 'General Error',
      value: diagnostics?.generalError,
    },
  ].some((item) => item.value) ? (
    <div className='space-y-3'>
      {[
        {
          label: 'Step 1 Error',
          value: diagnostics?.step1Error,
        },
        {
          label: 'PAN Verification Error',
          value: diagnostics?.step2Error,
        },
        {
          label: 'PAN Update Error',
          value: diagnostics?.step2UpdateError,
        },
        {
          label: 'Account Activation Error',
          value: diagnostics?.step3Error,
        },
        {
          label: 'Bank Verification Error',
          value: diagnostics?.step4Error,
        },
        {
          label: 'General Error',
          value: diagnostics?.generalError,
        },
      ]
        .filter((item) => item.value && String(item.value).trim() !== '[object Object]')
        .map((item, index) => (
          <div
            key={index}
            className='rounded-md border border-red-200 bg-red-50 p-3'
          >
            <p className='text-[11px] text-red-600 uppercase tracking-wide font-semibold'>
              {item.label}
            </p>

            <p className='text-sm mt-1 text-red-700 break-all'>
              {String(item.value)}
            </p>
          </div>
        ))}
    </div>
  ) : (
    <p className='text-sm text-muted-foreground'>
      No errors found.
    </p>
  )}
</div>
          </div>
        )}
      </div>

      {/* Financial Summary */}
      {/* <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <Wallet className='mr-2' size={20} />
          Financial Summary
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
          <div className='bg-green-500/10 border border-green-500/20 rounded-lg p-4'>
            <label className='text-xs text-muted-foreground'>Total Earnings</label>
            <p className='text-2xl font-bold text-green-600 mt-1'>
              ₹{seller?.financial?.totalEarnings?.toLocaleString() || 0}
            </p>
          </div>
          <div className='bg-yellow-500/10 border border-yellow-500/20 rounded-lg p-4'>
            <label className='text-xs text-muted-foreground'>Pending Payouts</label>
            <p className='text-2xl font-bold text-yellow-600 mt-1'>
              ₹{seller?.financial?.pendingPayouts?.toLocaleString() || 0}
            </p>
          </div>
          <div className='bg-blue-500/10 border border-blue-500/20 rounded-lg p-4'>
            <label className='text-xs text-muted-foreground'>Completed Payouts</label>
            <p className='text-2xl font-bold text-blue-600 mt-1'>
              ₹{seller?.financial?.completedPayouts?.toLocaleString() || 0}
            </p>
          </div>
        </div>
      </div> */}

      {/* Subscription */}
      {/* {seller?.subscription?.subscriptionId && (
        <div className='bg-card border border-border rounded-lg p-6'>
          <h2 className='text-lg font-semibold mb-4'>Subscription</h2>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <div>
              <label className='text-xs text-muted-foreground'>Start Date</label>
              <p className='text-sm font-medium mt-1'>{formatDateTime(seller.subscription.subscriptionStartDate)}</p>
            </div>
            <div>
              <label className='text-xs text-muted-foreground'>End Date</label>
              <p className='text-sm font-medium mt-1'>{formatDateTime(seller.subscription.subscriptionEndDate)}</p>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};

export default FinancialTab;

